"use client";


import ContactBanner from "@/app/[locale]/contact/_components/contact-banner";
import ContactFeature from "@/app/[locale]/contact/_components/contact-feature";

const ContactPage = () => {

	return (
		<>
			<ContactBanner />
			
			<ContactFeature />
		</>
	);
};

export default ContactPage;